import { Controller } from '@hotwired/stimulus'

// Copy a value to the clipboard (CMP-101c — the sensor signing secret). Reads
// the `source` target's value/text and briefly swaps the button to a "copied"
// label so the operator gets confirmation that the secret was copied.
export default class extends Controller {
  static targets = ['source', 'button']

  async copy () {
    const text = this.sourceTarget.value ?? this.sourceTarget.textContent
    await navigator.clipboard.writeText(text.trim())
    if (!this.hasButtonTarget) return

    // Capture innerHTML (not textContent) so an icon-only button restores its
    // icon after the transient "copied" label, instead of emptying out.
    const original = this.buttonTarget.innerHTML
    this.buttonTarget.textContent = this.buttonTarget.dataset.copiedLabel
    setTimeout(() => { this.buttonTarget.innerHTML = original }, 1500)
  }
}
